// Shared, reactive "which query tabs are currently running" state.
//
// QueryPanel keeps its run state locally, but the inner tab bar (a sibling in
// Browser.jsx) needs it to show a spinner on actively-running tabs. Rather than
// thread a callback up through Shell, each QueryPanel publishes its run state
// here keyed by tab id; the tab bar reads runningTabs[id] reactively.
import { createStore } from 'solid-js/store';

const [runningTabs, setRunningTabs] = createStore({}); // { [tabId]: true }

export { runningTabs };

export function setQueryTabRunning(tabId, running) {
  if (tabId == null) return;
  setRunningTabs(tabId, running ? true : undefined);
}
